import React from 'react';
// Importing router configuration
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// Import components
import Hero from './components/Hero';
import Header from './components/Header';
import About from './components/About';
import GallerySection from './components/GallerySection';
import Skills from './components/Skills';
import Services from './components/Services';
import Project from './components/Project';
// import Interview from './components/Interview';
import Testimonial from './components/Testimonial';
import Tribute from './components/Tribute';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Copyright from './components/Copyright';

// Helper component to determine if the current route is "/project"
const ShowMainContent = ({ children }) => {
  const location = useLocation();
  return location.pathname !== '/project' ? children : null;
};

const App = () => {
  return (
    <Router>
      <main className="max-w-[1920px] mx-auto overflow-hidden bg-white">
        {/* Navbar/Header */}
        <Header />

        {/* Conditional rendering for main sections */}
        <ShowMainContent>
          <section id="hero">
            <Hero />
          </section>
          <section id="about">
            <About />
          </section>
          <section id="gallery">
            <GallerySection />
          </section>
          <section id="services">
            <Services />
          </section>
          <section id="skills">
            <Skills />
          </section>
          <section id="tribute">
            <Tribute />
          </section>
          <section id="testimonials">
            <Testimonial />
          </section>
          <section id="contact">
            <Contact />
          </section>
          {/* Footer */}
          <Footer />
          <Copyright />
        </ShowMainContent>

        {/* Routes for the Project component */}
        <Routes>
          <Route path="/project" element={<Project />} />
        </Routes>
      </main>
    </Router>
  );
};

export default App;




// import React from 'react';
// //impoting router config
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// // import components
// import Hero from './components/Hero';
// import Header from './components/Header';
// import About from './components/About';
// import GallerySection from './components/GallerySection';
// import Skills from './components/Skills';
// import Services from './components/Services';
// import Project from './components/Project';
// // import Interview from './components/Interview';
// import Testimonial from './components/Testimonial';
// import Tribute from './components/Tribute';
// import Contact from './components/Contact';
// import Footer from './components/Footer';
// import Copyright from './components/Copyright';

// const App = () => {
//   return (
    
//     // old code with only project router
//   <Router>
//     <main className='max-w-[1920px] mx-auto overflow-hidden bg-white'>
//       {/* Navbar/Header */}
//       <Header />

//       <Routes>
//           <Route path="/project" element={<Project />} />
//       </Routes>

//       {/* Sections with IDs */}
//       <section id="hero">
//         <Hero />
//       </section>
//       <section id="about">
//         <About />
//       </section>
//       <section id="gallery">
//         <GallerySection />
//       </section>
//       <section id="services">
//         <Services />
//       </section>
//       <section id="skills">
//         <Skills />
//       </section>
//       <section id="tribute">
//         <Tribute />
//       </section>
//       <section id="testimonials">
//         <Testimonial />
//       </section>
//       <section id="contact">
//         <Contact />
//       </section>
//       {/* Footer */}
//       <Footer />
//       <Copyright />
//   </main>
//   </Router>
//   );
// };

// export default App;


      // {/* old code  */}
      // {/* <Header />
      // <Hero />
      // <About />
      // <GallerySection />
      // <Services/>
      // <Skills />
      // <Testimonial />
      // {/* <Interview /> // not included */}
      // {/* <Contact />
      // <Footer />
      // <Copyright /> 
      // <div className='h-[4000px]'></div> // not in use this line*/}